import { infiniteQueryOptions, keepPreviousData } from "@tanstack/react-query";

import { SortingRequestParams } from "../../shared/types/api-types";
import { SORT_DIRECTIONS } from "../../shared/types/sort";

import { getNewsList } from "./api";
import {
  NEWS_COUNT_PER_PAGE,
  NEWS_LIST_QUERY_KEY,
  NEWS_LIST_SORT_FIELDS,
} from "./constants";
import { NewsSortColumn } from "./types";

export const DEFAULT_NEWS_LIST_SORTING: SortingRequestParams<NewsSortColumn> = {
  columnName: NEWS_LIST_SORT_FIELDS.dateTimePublishing,
  direction: SORT_DIRECTIONS.desc,
};

export const getInfiniteNewsQueryOptions = () =>
  infiniteQueryOptions({
    queryKey: [NEWS_LIST_QUERY_KEY, DEFAULT_NEWS_LIST_SORTING],
    queryFn: ({ pageParam }) =>
      getNewsList({
        sorting: DEFAULT_NEWS_LIST_SORTING,
        pagination: {
          page: pageParam,
          countPerPage: NEWS_COUNT_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) =>
      lastPage.pagination?.hasMore
        ? lastPage.pagination.currentPage + 1
        : undefined,
    initialPageParam: 1,
    placeholderData: keepPreviousData,
  });
